module.exports = __webpack_public_path__ + "static/media/head-projects.79deab44.png";